<div *ngIf="!load; else loading" 

[style.background]="stream.coverImage ? 'url(/'+stream.coverImage+')' : false" class="wrapper">

    <div class="form"> 
         
	<div class="d-flex">
		<div class="d-flex"  style="flex:1;">
		    <input nbInput fullWidth (change)="password = $event.target.value" [value]="password" 
                     [placeholder]="stream.accessFormText || 'Введіть код'" type="text" />
		</div>

		<div class="d-flex" style="margin-left:10px;">
      
		    <button
       
        nbButton status="primary"  fullWidth (click)="submit()"
        [ngStyle]="{ 'background-color': isBlackButton ? '#000' : '', 'border-color': isBlackButton ? '#000' : '' }"
        
        >
		       {{ stream.accessFormButton || 'Дивитися'}}
		    </button>
		</div>

	</div>


	 <div *ngIf="stream.qrUnlocker"  style="margin-top:15px; display: flex;">
   	<a href="javascript:;"  class="mob-link"  [ngStyle]="{ 'color': isBlackButton ? '#000' : ''}"  (click)="openQrModal(qrModal)"><div class="mob-icon" *ngIf="!isBlackButton"></div> <span>{{ isEnglish ? 'Unlock via QR code' :  'Розблокувати через QR код' }}</span></a>
     </div>

	 <div *ngIf="stream.saleMode && stream.price" style="margin-top:15px; display: flex;  text-align:center;">
 		<button
     [ngStyle]="{ 'background-color': isBlackButton ? '#000' : '', 'border-color': isBlackButton ? '#000' : '' }"
       
    
    status="primary" nbButton (click)="buyNowKey()"  fullWidth>{{ isEnglish  ? 'Buy key for' : 'Купити код за' }} {{stream.price}} {{ isEnglish  ? 'UAH' : 'грн.' }}</button>
     </div>


 </div>



</div>        
<ng-template #loading>
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;">  <app-loader></app-loader> </div>
        </div>
</ng-template> 



 <ng-template #qrModal  let-data   let-ref="dialogRef">

  <div style="max-width:350px">
         <nb-card>
      
      <nb-card-body>
	<div style="text-align:center; margin-bottom:15px">
	
	{{ isEnglish  ? "Point your phone's camera, follow the link in the notification and enter the key on the phone's screen" : 'Наведіть камеру телефону, в повідомленні перейдіть за посиланням і на екрані телефону введіть код' }}
	
	</div>
<div class="flex-d">
    <div class="qrcodeWrp">
        
         
	<qrcode [qrdata]="qrLink" [width]="256"   [margin]="0" [errorCorrectionLevel]="'M'"></qrcode>
  
    </div> 
</div> 
  </nb-card-body>
      <nb-card-footer>
       
         
    <div style="display:flex; width:100%">
             
            <button  style="display:flex; margin-left:auto; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >{{ isEnglish ? 'Cancel' :'Скасувати'}}</button>

  
          </div>
      </nb-card-footer>
    </nb-card>
     
  </div>
    </ng-template>
    
